export const projectRevenueTableHeader = [
  {
    field: 'projectName',
    headerName: 'Project',
    width: 200,
  },
  {
    field: 'sales',
    headerName: 'Sales',
    width: 150,
  },
  {
    field: 'admissions',
    headerName: 'Admissions',
    width: 150,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'revenue',
    headerName: 'Revenue',
    width: 180,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'arpu',
    headerName: 'ARPU',
    width: 150,
    align: 'right',
    headerAlign: 'right',
  },
];
